import { Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import { useCompanyConfigContext } from "@/context/CompanyConfigContext";

export const TaskerHeader = () => {
  const theme = useTheme();
  const { company } = useCompanyConfigContext();

  const taskerConfig = company?.features?.tasker;
  const phoneNumber =
    taskerConfig && typeof taskerConfig !== "boolean"
      ? taskerConfig.phoneNumbers?.[0]
      : undefined;

  const handleSendMessage = () => {
    if (phoneNumber) {
      window.location.href = `sms:${phoneNumber}`;
    }
  };

  return (
    <>
      <Box
        sx={{
          mb: 2,
          p: 2,
          textAlign: "center",
          borderRadius: 1,
          boxShadow: "0 4px 12px rgba(102, 126, 234, 0.25)",
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 4%, ${theme.palette.primary.light} 100%)`,
        }}
      >
        <Typography
          variant="h3"
          component="h1"
          sx={{
            color: "white",
            fontWeight: 800,
            fontSize: { xs: "1.5rem", sm: "2rem", md: "2.25rem" },
            textShadow: "0 2px 4px rgba(0,0,0,0.15)",
          }}
        >
          Weekly Performance
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: "white",
            fontSize: { xs: "0.8rem", sm: "0.9rem" },
            fontWeight: 500,
          }}
        >
          Your messages for the last 7 days
        </Typography>
      </Box>
      {phoneNumber && (
        <Button
          onClick={handleSendMessage}
          fullWidth
          sx={{
            mb: 2,
            p: { xs: 1.5, sm: 2 },
            textAlign: "center",
            borderRadius: 1,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            transition: "all 0.3s ease",
            "&:hover": {
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
              background: `linear-gradient(135deg, ${theme.palette.success.dark} 0%, ${theme.palette.success.main} 100%)`,
              transform: "translateY(-2px)",
            },
            textTransform: "none",
          }}
        >
          <MessageIcon
            sx={{ color: "white", fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
          />

          <Typography
            variant="h6"
            sx={{
              color: "white",
              fontWeight: 600,
              fontSize: { xs: "0.9rem", sm: "1.1rem" },
            }}
          >
            Text your submissions to: {phoneNumber}
          </Typography>
        </Button>
      )}
    </>
  );
};
